export default __webpack_public_path__ + "images/avatar_stop.c27d7571.png";